import axios from 'axios';

const toBase64 = (value) => {
  return btoa(String(value));
};

export const returnRequest = async ({
  token,
  orderId,
  orderItemId,
  selectedCustomAttributes, // Expecting an array of objects { attribute_code, value }
}) => {
  try {
    // Convert the array to GraphQL-compliant string
    const customAttributesString = selectedCustomAttributes.map(attr => {
      return `{
        attribute_code: "${attr.attribute_code}",
        value: "${toBase64(attr.value)}"
      }`;
    }).join(',\n');

    const data = JSON.stringify({
      query: `
        mutation {
          requestReturn(
            input: {
              order_uid: "${toBase64(orderId)}",
              items: [
                {
                  order_item_uid: "${toBase64(orderItemId)}",
                  quantity_to_return: 1,
                  selected_custom_attributes: [
                    ${customAttributesString}
                  ]
                }
              ]
            }
          ) {
            return {
              uid
              items {
                uid
                status
                request_quantity
                quantity
                order_item {
                  id
                  eligible_for_return
                  product_sku
                  product_type
                  quantity_returned
                  status
                }
              }
              number
              status
              comments {
                uid
                author_name
                text
                created_at
              }
              customer {
                firstname
                lastname
                email
              }
            }
          }
        }
      `
    });

    const config = {
      method: 'post',
      url: 'https://mcstaging.candere.com/graphql',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      withCredentials: true,
      data: data,
    };

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error("Failed to request return:", error.response?.data || error.message);
    return null;
  }
};